var _path, _polyline, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.536,15.732c.295-.976.657-1.979,1.086-2.991,2.667-6.293,6.392-10.985,8.946-9.902.515.218.923.636,1.223,1.215"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "13.936 14.03 9.381 16.101 7.305 11.534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.919,6.885c2.43,3.68,2.025,8.681-1.215,11.921-3.703,3.703-9.706,3.703-13.409,0s-3.703-9.706,0-13.409c2.241-2.241,5.325-3.126,8.232-2.654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongitude);
export default __webpack_public_path__ + "static/media/longitude.1fbfe41008cee3b8cca60c24fdca608e.svg";
export { ForwardRef as ReactComponent };